<template>
  <div class="order-detail" v-show="loaded">
    <div class="toshare" v-show="showShareMask" @click="onShareMaskClick">
      <img src="/static/img/toshare.png" />
    </div>
    <div class="space"></div>
    <div class="section-title">
      订单编号
      <span>{{ order.order_no }}</span>
      <div class="share" :class="{yellow: !order.is_shared}">{{ order.share_status_title }}</div>
    </div>
    <div class="info-card">
      <ul class="info-cont">
        <li>
          <span class="label">订单状态</span>
          <span class="blue">{{ order.order_status_title }}</span>
        </li>
        <li>
          <span class="label">下单时间</span>
          <span>{{ order.create_time }}</span>
        </li>
      </ul>
      <div class="subtitle-info top-line top-solid-line">套餐信息</div>
      <ul class="info-cont">
        <li>
          <span class="label">套餐名称</span>
          <span>{{ order.product_pkg_title }}</span>
        </li>
        <li>
          <span class="label">套餐价格</span>
          <span>{{ order.order_price }}元</span>
        </li>
        <li>
          <span class="label">抵扣金额</span>
          <span>{{ order.dikou_amount }}元</span>
        </li>
        <li>
          <span class="label">应付金额</span>
          <span>{{ order.pay_price }}元</span>
        </li>
        <li v-if="!order.has_signed">
          <span class="label">服务时长</span>
          <span>{{ order.service_period }}个月</span>
        </li>
        <li v-if="order.has_signed">
          <span class="label">服务时间</span>
          <span>{{ order.service_start_date }} 至 {{order.service_end_date}}</span>
        </li>
      </ul>
      <div class="subtitle-info top-line top-solid-line">购买人信息</div>
      <ul class="info-cont">
        <li>
          <span class="label">姓名</span>
          <span>{{ order.customer_name }}</span>
        </li>
        <li>
          <span class="label">手机号码</span>
          <span>{{ order.security_mobile || '无'}}</span>
        </li>
        <li>
          <span class="label">回执编号</span>
          <span>{{ order.survey_code || '无'}}</span>
        </li>
      </ul>
      <div class="subtitle-info top-line top-solid-line" v-if="payments.length > 0">付款信息</div>
      <order-pay-item
        v-for="(item, index) in payments"
        :key="item.payment_id"
        :payment="item"
        role="customer"
        :last="index == payments.length-1"
      ></order-pay-item>
      <div class="subtitle-info top-line top-solid-line" v-if="canTrans">查账信息相关</div>
      <ul class="info-cont" v-if="canTrans">
        <li @click="toTransFillIn">
          <a href="javascript:void(0);" class="yellow" v-text="transTips"></a>
        </li>
      </ul>
      <div class="subtitle-info top-line top-solid-line">分享链接</div>
      <ul class="info-cont">
        <li>
          <a
            v-clipboard:copy="share.link"
            v-clipboard:success="onCopied"
            href="javascript:void(0);"
            class="blue"
          >复制链接分享给客户</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import OrderPayItem from "@/components/OrderPayItem";

export default {
  name: "OrderDetail",
  data: () => ({
    order: {},
    customer: {},
    payments: [],
    share: {},
    loaded: false,
    showShareMask: false,
    transTips: "去代客户录入查账信息",
    canTrans: false
  }),
  computed: {
    statusClass() {
      if (this.order.is_shared) {
        return "shared";
      }
      return "share";
    }
  },
  created() {},
  components: {
    OrderPayItem
  },
  mounted: function() {
    this.setPageTitle("订单详情");
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.loading("正在读取订单信息...");
      this.getOrderFullDetail(this.$route.params.id, "full", rs => {
        this.order = rs.data.order;
        this.customer = rs.data.customer;
        this.share = rs.data.share;
        this.payments = rs.data.payments;
        this.showShareMask = this.order.is_shared === false;
        this.configShare(rs.data.share);
        this.loaded = true;
        if (this.order.is_staff_help === 1) {
          this.canTrans = true;
          if (this.order.pay_status === 70) {
            this.transTips = "去更正查账信息";
          } else if (this.order.pay_status === 60) {
            if (
              !this.order.survey_code ||
              this.order.survey_code.length === 0
            ) {
              this.transTips =
                "您的客户还未完成问卷，请去引导客户使用分享链接完成问卷";
            } else {
              this.transTips = "查账信息正在核实中";
            }
          } else if (this.order.pay_status === 30) {
            this.transTips = "查账信息核实成功";
          }
        } else if (this.order.pay_kind !== 30) {
          this.canTrans = true;
        }
      });
    },
    toTransFillIn() {
      if (this.order.order_status < 20) {
        this.toast("客户尚未确认订单，请通知客户确认订单");
        return;
      }
      if (
        this.order.pay_status === 0 ||
        this.order.pay_status === 10 ||
        this.order.pay_status === 20 ||
        this.order.pay_status === 11 ||
        this.order.pay_status === 70
      ) {
        this.$store.dispatch("setOrder", { order: this.order });
        this.$store.dispatch("setSelectedPayway", {
          item: { routeCode: "P0000" }
        });
        this.$router.push("/trans/" + this.order.order_no);
      } else if (this.order.pay_status === 30) {
        this.toast("查账信息核实成功");
      } else if (this.order.pay_status === 60 && this.order.survey_code) {
        this.toast("查账信息核实中");
      }
    },
    onShareMaskClick() {
      this.showShareMask = false;
    },
    saveShareResult(opFlag) {
      let url = "/api/orders/shares/" + this.$route.params.id;
      let params = {
        order_no: this.$route.params.id,
        share_token: this.share.token,
        to_plat_name: "微信App"
      };
      this.$http.put(url, params).then(
        response => {
          console.log(response);
          var rs = response.body;
          if (rs.code === 0) {
            this.order = rs.data;
            if (opFlag) {
              this.toast("已复制");
            }
          } else {
            this.handleHttpError(response);
          }
        },
        response => {
          console.log(response);
          this.handleHttpError(response);
        }
      );
    },
    onCopied() {
      this.saveShareResult();
    },
    configShare(data) {
      if (!data) {
        return;
      }
      // 只可设置同域链接
      // window.history.pushState('weixin-share-url', 'weixinshare', data.link)
      wx.config({
        debug: false,
        appId: data.sign.appId,
        timestamp: data.sign.timestamp,
        nonceStr: data.sign.nonceStr,
        signature: data.sign.signature,
        jsApiList: ["checkJsApi", "onMenuShareAppMessage"]
      });
      let self = this;
      wx.ready(function() {
        wx.checkJsApi({
          jsApiList: ["onMenuShareAppMessage"] // 需要检测的JS接口列表，所有JS接口列表见附录2,
        });
        wx.onMenuShareAppMessage({
          title: data.title,
          desc: data.desc,
          link: data.link,
          imgUrl: "http://" + document.domain + "/static/img/logo2.png",
          success: function(res) {
            console.log(res);
            self.saveShareResult(true);
          },
          cancel: function(res) {
            console.log(res);
          }
        });
        self.saveShareResult(false);
      });
      wx.error(function(res) {
        self.showShareMask = false;
        console.log(res);
        self.toast(res);
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// OrderDetail.vue?00c64476